// extracted by mini-css-extract-plugin
export var logo = "logo-module--logo--oxEbf";
export var section = "logo-module--section--ZKktU";